var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCopyOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 8C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6H10C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8H13Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 10C14 10.5523 13.5523 11 13 11H10C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9H13C13.5523 9 14 9.44772 14 10Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 13C12 13.5523 11.5523 14 11 14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H11C11.5523 12 12 12.4477 12 13Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 18C6.34315 18 5 16.6569 5 15V5C5 3.34315 6.34315 2 8 2H15C16.6569 2 18 3.34315 18 5V15C18 16.6569 16.6569 18 15 18H8ZM7 15C7 15.5523 7.44772 16 8 16H15C15.5523 16 16 15.5523 16 15V5C16 4.44772 15.5523 4 15 4H8C7.44772 4 7 4.44772 7 5V15Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M2 15C2 15.5523 2.44772 16 3 16C3.55228 16 4 15.5523 4 15V5C4 4.44771 3.55228 4 3 4C2.44772 4 2 4.44771 2 5V15Z",
  fill: "currentColor"
})));
export { SvgCopyOutline20 as ReactComponent };